import { date, file, image, minDate, prop, required } from '@rxweb/reactive-form-validators';

export class AdsModel {
    @required()
    name: string;

    @prop({name: 'routes_id'})
    routesId: string;

    @required()
    type: string;

    @required({
        conditionalExpression: '(itemFormGroup, rootFormGroup) => itemFormGroup.type === "video"'
    })
    url: string;

    @required({
        message: 'te falta una imagen',
        conditionalExpression: '(itemFormGroup, rootFormGroup) => itemFormGroup.type === "image" && itemFormGroup.imageUrl === null'
    })
    image: string;

    @prop({name: 'image_url'})
    imageUrl: string;

    @date({
        allowISODate: true
    })
    @prop({name: 'active_from'})
    activeFrom: string;

    @minDate({
        fieldName: 'activeFrom',
        message: 'Este campo es opcional, pero de usarlo, tiene que ser mayor que {{0}}',
        allowISODate: true
    })
    @prop({name: 'active_to'})
    activeTo: string;

    @required()
    active: string;
}
